import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function DailyMaterialInOutReport (props){
    
    const table = "DailyMaterialInOutReport";
    const view = "DailyMaterialInOutReport";

    const { date, setView, setExcelFileName, onSearchInitialized, onFilterInitialized, apiInitialized,} = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if ( date && api ) {

            // 엑셀 다운로드는 보고 있는 탭의 뷰 · 이름으로 받는다 — 일별도 알려야 처음 연 화면 · 주별 뒤 일별에서 일별을 받는다(기간별 수불부는 넘기지 않는다)
            setView?.(view);
            setExcelFileName?.("일간");
            
            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api, date ] );

    const onApiInitialized = ( api ) => {

        if(apiInitialized) {
            apiInitialized(api)
        } 

        setApi ( api );

    };

    const onGridInitialized = ( grid ) => {
        grid.allowSorting = false;
    };

    const onModifyUrl = ( url ) => {

        let newUrl = `${url}/${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()}`        

        return newUrl;
    };

    return (
    
        <BasicCrudScreenType
            id="DailyMaterialInOutReport"
            noHeader
            table={table}
            view={view}
            onModifyViewUrl={onModifyUrl}
            onApiInitialized={onApiInitialized}
            onSearchInitialized={onSearchInitialized}
            onFilterInitialized={onFilterInitialized}
            onInitialized={onGridInitialized}
        />

    );

}
export default DailyMaterialInOutReport;